<template>
  <div>
    <label class="t-mb-0 t-text-gray-900">{{ labelText }}</label>

    <div class="t-relative">
      <div
        v-if="showDropdown"
        role="menu" aria-orientation="vertical" aria-labelledby="options-menu"
        class="t-absolute t-origin-top-left t-bottom-0 t-shadow-lg t-border t-border-gray-400 t-w-full t-py-1 t-bg-white"
      >
        <div
          v-for="(day, index) in DAYS_IN_WEEK"
          @click="onBusinessDayChanged('NORMAL', index)"
          :key="index"
          role="menuitem"
          class="t-px-4 t-py-2 t-text-sm t-text-gray-900 t-w-full hover:t-bg-gray-100 hover:t-text-gray-900"
        >
          {{ day }}
        </div>
      </div>
    </div>

    <button
      @click="onDropdownButtonClick"
      v-click-outside="onClickOutside"
      type="button"
      class="t-justify-center t-w-full t-rounded-md t-border t-border-gray-400 t-shadow-sm
      t-px-4 t-py-2 t-bg-white t-text-sm t-font-medium t-text-gray-800"
    >
      {{ DAYS_IN_WEEK[dayIndex] }}
    </button>
  </div>
</template>

<script>
export default {
  name: 'BusinessDaysDropdown',
  props: {
    labelText: {
      type: String
    },
    index: {
      type: Number
    },
    // Index of day in a week where Monday is 0
    dayIndex: {
      type: Number, default: 0
    }
  },
  emits: ['businessDayChanged'],
  data() {
    return {
      showDropdown: false
    }
  },
  created() {
    this.DAYS_IN_WEEK = ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday'];
  },
  methods: {
    onDropdownButtonClick() {
      this.showDropdown = !this.showDropdown;
    },
    onClickOutside() {
      this.showDropdown = false;
    },
    onBusinessDayChanged(hoursType, index) {
      this.$emit('businessDayChanged', hoursType, index)
    }
  }
}
</script>

<style scoped>

</style>